<template>
  <div class="project-field">
    <label
      v-if="fieldLabel"
      class="emphasis project-field__label"
    >
      {{ fieldLabel }}:
    </label>
    <slot
      v-else
      name="label"
    />
    <div class="field__column">
      <div
        v-if="editingFlag"
        ref="fieldRef"
        class="field__edit"
      >
        <slot />
      </div>
      <div
        v-else
        class="field__display"
      >
        <span
          v-if="displayValue"
          class="field__display-text"
          @dblclick="doubleClick"
        >
          {{ displayValue }}
        </span>
        <slot
          v-else
          name="display-show"
        />
        <i
          v-if="isEditable"
          class="fa fa-pencil icon pointer"
          @click="editingAction"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import { onClickOutside } from '@vueuse/core'

export default {
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
    fieldLabel: {
      type: String,
      default: undefined,
    },
    displayValue: {
      type: String,
      default: undefined,
    },
  },
  setup (props, { emit }) {
    const fieldRef = ref(null)
    const editingFlag = ref(false)
    const isEditable = computed(() => {
      return props.canEdit
    })

    const open = () => {
      if (isEditable) editingFlag.value = true
      emit('openPencil')
      emit('open')
    }
    const close = () => {
      if (editingFlag.value) {
        editingFlag.value = false
        emit('closePencil')
        emit('close')
      }
    }
    const editingAction = () => open()

    onClickOutside(fieldRef, () => close())
    return {
      isEditable,
      fieldRef,
      editingFlag,
      editingAction,
      open,
      close,
      doubleClick: (...args) => emit('dblclick', ...args),
    }
  },
}
</script>

<style lang="scss" scoped>

.project-field {
  &__label {
    margin: 0 0;
    margin-bottom: 6px;
  }
}
.field__display {
  margin-bottom: 6px;
  pre {
    display: inline;
  }
  .fa-pencil {
    color: #1779ba;
  }
  .field__display-text {
    color: #0C3A58;
  }
}
.field__edit {
  display: inline-block;
}
</style>>
